import React from "react";

export const GoogleIcon = ({ className = "w-5 h-5" }) => {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2286_241)">
        <path d="M15.6039 6.76714L15.5232 6.42464H8.07893V9.57536H12.5268C12.065 11.7682 9.92214 12.9225 8.17179 12.9225C6.89821 12.9225 5.55571 12.3868 4.66714 11.5257C4.19833 11.0642 3.82516 10.5147 3.569 9.90868C3.31283 9.30271 3.1787 8.65216 3.17429 7.99429C3.17429 6.66714 3.77071 5.33964 4.63857 4.46643C5.50643 3.59321 6.81714 3.10464 8.12036 3.10464C9.61286 3.10464 10.6825 3.89714 11.0825 4.25857L13.3214 2.03143C12.6646 1.45429 10.8604 0 8.04821 0C5.87857 0 3.79821 0.831071 2.2775 2.34679C0.776786 3.83929 0 5.9975 0 8C0 10.0025 0.735 12.0529 2.18929 13.5571C3.74321 15.1614 5.94393 16 8.21 16C10.2718 16 12.2261 15.1921 13.6189 13.7264C14.9882 12.2836 15.6964 10.2871 15.6964 8.19429C15.6964 7.31321 15.6079 6.79 15.6039 6.76714Z" fill="#0A0A0A" />
      </g>
      <defs>
        <clipPath id="clip0_2286_241">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

